import React from 'react';

import { LazyWatermarkConfigurationPage } from '@confluence/site-settings/entry-points/WatermarkConfigurationPage';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminWatermarkConfigurationRoute = () => <LazyWatermarkConfigurationPage />;

AdminWatermarkConfigurationRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'adminWatermarkConfiguration' },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
